module.exports = __webpack_public_path__ + "img/icon-pinjaman-kantor.a5e76d99.svg";